import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InsightsJobsEffects, InsightsJobsReducer } from './state';

@NgModule({
  imports: [
    StoreModule.forFeature('insights-jobs', InsightsJobsReducer),
    EffectsModule.forFeature([InsightsJobsEffects]),
  ]
})
export class InsightsJobsStateModule { }
